<script lang="ts">
	import { createEventDispatcher } from "svelte";
	// Type
	import type { CategoryMinData } from "@hitit/api";

	//Image
	import upArrow from "@hitit/hub/src/assets/Icons/upArrow.png";
	import downArrow from "@hitit/hub/src/assets/Icons/downArrow.png";

	//Ui
	import ItemBox from "./ItemBox.svelte";

	export let value = "";
	export let defaultClassName = "";
	export let categorys: CategoryMinData[] = [];
	export let editmode = false;
	export let index: number;
	export let categoryOpen: boolean = false;

	const dispatch = createEventDispatcher();

	function categoryChangeHandler() {
		dispatch("CHANGE_CATEGORY", {
			index,
			categoryOpen,
		});
	}
</script>

<div class="container" class:editmode={editmode} t-id="CategorySelectBox">
	{#if editmode}
		<button class="outer-button" on:click={() => categoryChangeHandler()}>
			<span class="category-text">{value}</span>
			<img src={categoryOpen ? upArrow : downArrow} />
		</button>
		{#if categoryOpen}
			<button class="inner-container-button">
				{#each categorys as category}
					<ItemBox
						category={category}
						bind:value={value}
						bind:categoryOpen={categoryOpen}
					/>
				{/each}
			</button>
		{/if}
	{:else}
		<p>{value}</p>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		position: relative;
		display: flex;
		width: 100%;
		height: 22px;
		&.editmode {
			height: 30px;
		}

		button {
			all: unset;
			display: flex;
			background-color: #f0f0f4;
			border-radius: 5px;
			padding: 0px 5px;
			cursor: pointer;
		}

		.outer-button {
			justify-content: space-between;
			align-items: center;
			width: 100%;
			overflow: hidden;

			.category-text {
				width: 100%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.inner-container-button {
			width: 273px;
			max-height: 518px;
			overflow: hidden;
			position: absolute;
			display: flex;
			flex-direction: column;
			left: 0px;
			top: 40px;
			z-index: 1;
		}

		.category-box {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		img {
			width: 15px;
			height: 8px;
		}
	}

	@include DesktopSize {
		.container {
			position: relative;
			display: flex;
			width: 273px;
			height: 30px;
			&.editmode {
				height: 40px;
			}

			button {
				all: unset;
				display: flex;
				background-color: #f0f0f4;
				border-radius: 5px;
				padding: 0px 10px;
				cursor: pointer;
			}

			.outer-button {
				justify-content: space-between;
				align-items: center;
				width: 100%;
			}

			.inner-container-button {
				width: 253px;
				max-height: 518px;
				overflow: hidden;
				position: absolute;
				display: flex;
				flex-direction: column;
				left: 0px;
				top: 50px;
				z-index: 1;
			}

			.category-box {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}

			img {
				width: 20px;
				height: 10px;
			}
		}
	}
</style>
